<button color="accent" mat-icon-button [matTooltip]="'asset.select_default_location' | transloco"
  (click)="toggleMapDialog()">
  <mat-icon color="accent">add_location_alt</mat-icon>
</button>
<div class="inputs">
  <mat-form-field class="loren-form-field">
    <mat-label>{{ "asset.default_location_latitude" | transloco }}</mat-label>
    <input
      matInput
      [disabled]="disabled"
      [value]="_value.lat"
      (input)="updateLatitude($any($event.target).value)"
      />
    @if (_value.lat) {
      <button
        matSuffix
        mat-icon-button
        color="accent"
        aria-label="Clear"
        (click)="clearLatitude()">
        <mat-icon color="accent">close</mat-icon>
      </button>
    }
  </mat-form-field>
  <mat-form-field class="loren-form-field">
    <mat-label>{{ "asset.default_location_longitude" | transloco }}</mat-label>
    <input
      matInput
      [disabled]="disabled"
      [value]="_value.lng"
      (input)="updateLongitude($any($event.target).value)"
      />
    @if (_value.lng) {
      <button
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="clearLongitude()">
        <mat-icon color="accent">close</mat-icon>
      </button>
    }
  </mat-form-field>
</div>
